
import { Search, X } from 'lucide-react';

interface FilterSearchProps {
  search: string;
  onSearchChange: (search: string) => void;
}

const FilterSearch = ({ search, onSearchChange }: FilterSearchProps) => {
  return (
    <div className="relative">
      <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
      <input
        type="text"
        placeholder="Keresés esemény, szervező vagy címke alapján..."
        value={search}
        onChange={e => onSearchChange(e.target.value)}
        className="w-full pl-10 pr-4 py-2 rounded-lg border border-gray-200 focus:border-medihub-primary focus:ring-1 focus:ring-medihub-primary outline-none transition-all"
      />
      {search && (
        <button
          onClick={() => onSearchChange('')}
          className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
        >
          <X size={16} />
        </button>
      )}
    </div>
  );
};

export default FilterSearch;
